import Layout from '../../components/Layout.js'; 

import './error.css';

function ErrorPage() {
    return (
        <Layout pageIndex={-1}>
            <div style={{height:"70dvh", paddingTop:"128px"}}>

            <h1 className='errorcodeText'>404</h1>
            <p className='errorcodeSubtitle'>Looks like something went wrong...</p>
            </div>

        </Layout>
    );
}

export default ErrorPage;
